import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PhoneCall, Check, RotateCcw } from "lucide-react";

const dataOra = (s) => (s ? new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

/** Chi ha chiesto di essere contattato dopo la prova guidata della demo. */
export const RichiesteDemo = ({ client }) => {
  const [righe, setRighe] = useState(null);
  const [soloDaFare, setSoloDaFare] = useState(true);

  const carica = () => client.get("/admin/leads").then((r) => setRighe(r.data)).catch(() => setRighe([]));
  useEffect(() => { carica(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const segna = async (l, handled) => {
    try {
      await client.post(`/admin/leads/${l.id}/handled`, { handled });
      setRighe((c) => c.map((x) => (x.id === l.id ? { ...x, handled } : x)));
      toast.success(handled ? `${l.business}: segnato come contattato` : `${l.business}: torna da fare`);
    } catch {
      toast.error("Non salvato");
    }
  };

  if (!righe) return <p className="text-sm text-slate-400">Carico le richieste…</p>;

  const daFare = righe.filter((x) => !x.handled);
  const viste = soloDaFare ? daFare : righe;

  return (
    <Card className="space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100" data-testid="richieste-demo">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="font-head flex items-center gap-2 text-lg font-bold">
            <PhoneCall className="h-4 w-4" /> Richieste dalla demo
          </h2>
          <p className="mt-0.5 text-xs text-slate-400">
            {daFare.length === 0 ? "Nessuno da richiamare" : `${daFare.length} da richiamare`} · {righe.length} in totale
          </p>
        </div>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" onClick={() => setSoloDaFare((v) => !v)} data-testid="leads-filtro-btn">
            {soloDaFare ? "Mostra tutte" : "Solo da richiamare"}
          </Button>
          <Button size="sm" variant="outline" onClick={carica} data-testid="leads-ricarica-btn">
            <RotateCcw className="mr-1 h-3.5 w-3.5" /> Aggiorna
          </Button>
        </div>
      </div>

      {viste.length === 0 ? (
        <p className="text-sm text-slate-400" data-testid="leads-vuoto">
          Qui finiscono i contatti di chi completa la prova guidata e chiede di essere richiamato.
        </p>
      ) : (
        <div className="space-y-2">
          {viste.map((l) => (
            <div key={l.id} className={`flex flex-wrap items-center gap-3 rounded-xl border p-3 ${
              l.handled ? "border-slate-800 bg-slate-900/40" : "border-amber-500/40 bg-amber-500/5"}`}
              data-testid={`lead-${l.id}`}>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-bold">{l.business}</p>
                <p className="mt-0.5 text-xs text-slate-400">
                  {l.city || "città non detta"} · {dataOra(l.created_at)} · {l.source}
                </p>
              </div>
              <a href={`tel:${l.phone}`} className="font-num text-sm font-semibold text-amber-400"
                 data-testid={`lead-tel-${l.id}`}>
                {l.phone}
              </a>
              <a href={`https://wa.me/${l.phone.replace(/\D/g, "").replace(/^0/, "39")}`} target="_blank" rel="noreferrer"
                 className="text-xs font-semibold text-emerald-400" data-testid={`lead-wa-${l.id}`}>
                WhatsApp
              </a>
              <Button size="sm" variant={l.handled ? "outline" : "default"} onClick={() => segna(l, !l.handled)}
                      data-testid={`lead-fatto-${l.id}`}>
                <Check className="mr-1 h-3.5 w-3.5" /> {l.handled ? "Da rifare" : "Fatto"}
              </Button>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
